import {
  receiveServerErrors,
  receiveValidationErrors,
  RESET_LOADING,
} from "../Shared/Errors/errorActions";
import {
  receiveCurrentSession,
  REQUEST_CURRENT_SESSION,
  RECEIVE_CURRENT_SESSION,
  requestCurrentSession,
} from "./session_actions";
import { handleLogin } from "@store/authentication";
import { receiveServerMessage } from "../Shared/ServerMessages/ServerMessageActions";
import { findInfluencerVideos } from "../Pages/Influencer/influencer_actions";
import Cookies from "js-cookie";
import axios from "axios";

export const RECEIVE_CATEGORY_NAMES = "RECEIVE_CATEGORY_NAMES";
export const RECEIVE_BRAND_NAMES = "RECEIVE_BRAND_NAMES";

const receiveCategories = (categories) => ({
  type: RECEIVE_CATEGORY_NAMES,
  categories,
});

const receiveBrands = (brands) => ({ type: RECEIVE_BRAND_NAMES, brands });

export const createUser = (data, callback) => (dispatch) => {
  dispatch({ type: REQUEST_CURRENT_SESSION });
  $.ajax({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/users`,
    data,
    success(session) {
      dispatch(receiveCurrentSession(session));
      dispatch(handleLogin(session.currentUser));
      Cookies.set("uId", session.currentUser._id);
      // Cookies.set('jwt', session.jwt)
      localStorage.setItem("session", JSON.stringify(session));
      callback(session);
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};

export const signup = (data, callback, fieldError) => (dispatch) => {
  dispatch(requestCurrentSession());
  axios
    .post(
      `${process.env.REACT_APP_BASE_URL}/jwt_api/login/user_sign_up`,
      data,
      {}
    )
    .then((res) => {
      const { data } = res;
      if (!data.roles.includes("vip_influencer")) {
        dispatch(receiveCurrentSession(data));
        dispatch(handleLogin(data.currentUser));
        Cookies.set("uId", data.currentUser._id);
        Cookies.set("jwt", data.jwt);
        localStorage.setItem("session", JSON.stringify(data));
      }
      callback(data);
    })
    .catch((err) => {
      if (
        err.response.data.code === 208 &&
        err.response.data.error_message ===
          "There is already an account with this email."
      ) {
        err.response.responseJSON = [err.response.data.error_message];
        dispatch(
          receiveValidationErrors({ email: err.response.data.error_message })
        );
        dispatch({ type: RESET_LOADING });
      } else if (err.response.data.code === 208) {
        fieldError(err.response.data.error_message);
        err.response.responseJSON = [err.response.data.error_message];
        dispatch(receiveServerErrors(err.response));
      }
    });
};

export const updateUser = (data, triggerAVA) => (dispatch) => {
  dispatch({ type: REQUEST_CURRENT_SESSION });
  $.ajax({
    method: "put",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/users/current`,
    data,
    success(session) {
      if (triggerAVA) {
        dispatch(findInfluencerVideos(session.influencer._id));
      }
      dispatch(receiveCurrentSession(session));
      dispatch(receiveServerMessage("Profile successfully updated!"));
    },
    error(xhr) {
      dispatch(receiveServerErrors(xhr));
    },
  });
};
